import axios, { AxiosRequestConfig } from 'axios'
import { ReadBalanceRequestDto, TradingBalanceResponseDto } from '@sparling/financial-common'

export const getBalances = async (
  { token }: ReadBalanceRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<TradingBalanceResponseDto[]> => {
  const response = await axios.get(`${process.env.REACT_APP_REST_API_URL}/trading/balance/treasury`, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
  return response.data
}
